// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class AutomaticAction extends WebComponent {
	didMount() {
		const {
		} = this.props;

		if(this.props.targetId != null) {
			let target = document.querySelector('[id^="' + this.props.targetId + '"]');
			if(typeof (target) !== 'undefined') {
				switch (this.props.targetAction) {
					case 'click':
						target.click();
						break;
					default:
				}
			}
		}
	}
}



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/AutomaticAction.js